var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgGiftbox01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 54,
    viewBox: "0 0 81 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "hgx8ozp3xa"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 9247",
    style: {
      fill: "none"
    },
    d: "M0 0h81v54H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 10162",
    style: {
      clipPath: "url(#hgx8ozp3xa)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 38565",
    d: "M99.533 89.067V61.938h-18.5a1.6 1.6 0 0 0-1.6 1.582v32.169h13.4z",
    transform: "translate(-53.259 -41.751)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 38566",
    d: "M132.13 159.9h2.733v-2.7z",
    transform: "translate(-88.589 -105.966)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 38567",
    d: "M237.2 165.361v-.061l-.065.064z",
    transform: "translate(-158.993 -111.424)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 38568",
    d: "m197.971 129.97 4.029-3.983v-13.192l-17.368 17.175z",
    transform: "translate(-123.791 -76.033)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 38569",
    d: "m177.342 94.628 19.768-19.553V64a1.575 1.575 0 0 0-.778-1.349l-18.99 18.782z",
    transform: "translate(-118.903 -42.233)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 38570",
    d: "M192.605 61.938h-15.263v15.1z",
    transform: "translate(-118.903 -41.751)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 38571",
    d: "m177.342 80.953 18.99-18.782a1.533 1.533 0 0 0-.186-.1c-.022-.01-.045-.016-.068-.025a1.627 1.627 0 0 0-.2-.062l-.083-.018a1.583 1.583 0 0 0-.283-.028H192.6l-15.263 15.1z",
    transform: "translate(-118.903 -41.751)",
    style: {
      fill: "#f5ceb8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 38572",
    d: "M177.342 121.863h2.4l17.366-17.176v-3.92l-19.766 19.553z",
    transform: "translate(-118.902 -67.925)",
    style: {
      fill: "#f5ceb8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 38573",
    d: "m229.073 157.254.065-.064v-3.92l-4.028 3.984z",
    transform: "translate(-150.929 -103.317)",
    style: {
      fill: "#f5ceb8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 38574",
    d: "M158.383 12.96S162.471 0 172.735 0c1.427.846 5.988 5.636 3.708 18.032-5.132-2.255-18.06-5.072-18.06-5.072",
    transform: "translate(-106.191 .001)",
    style: {
      fill: "#c41f1f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 38575",
    d: "M120.365 12.96S116.278 0 106.013 0c-1.425.846-5.987 5.636-3.706 18.032 5.132-2.255 18.059-5.072 18.059-5.072",
    transform: "translate(-68.173 .001)",
    style: {
      fill: "#e32424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 38576",
    d: "M92.359 61.938 79.435 74.72v3.919l16.886-16.7z",
    transform: "translate(-53.259 -41.751)",
    style: {
      fill: "#f5ceb8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 38577",
    d: "M109.66 61.938 79.435 91.832v3.92l34.187-33.813z",
    transform: "translate(-53.259 -41.751)",
    style: {
      fill: "#f5ceb8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 9238",
    d: "M4.854 0h47.907a4.855 4.855 0 0 1 4.855 4.855v1.538a4.854 4.854 0 0 1-4.854 4.854H4.855A4.855 4.855 0 0 1 0 6.392V4.854A4.854 4.854 0 0 1 4.854 0z",
    transform: "translate(23.384 10.695)",
    style: {
      fill: "#5e382b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 9239",
    transform: "translate(46.274 10.695)",
    style: {
      fill: "#e32424"
    },
    d: "M0 0h12.166v11.247H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 9240",
    transform: "translate(52.357 10.695)",
    style: {
      fill: "#c41f1f"
    },
    d: "M0 0h6.083v11.247H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 9241",
    transform: "translate(26.177 21.943)",
    style: {
      fill: "#a36c4d"
    },
    d: "M0 0h52.031v1.815H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 38578",
    d: "m126.8 145.175-6.7 6.622h3.963l2.733-2.7z",
    transform: "translate(-80.527 -97.86)",
    style: {
      fill: "#f5ceb8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD569\\uCE58\\uAE30 26",
    d: "M0 33.751v-2.7l6.083-6.017L0 31.048v-3.919l6.083-6.016v12.638zM0 0h6.083v21.112L0 27.129z",
    transform: "translate(46.274 20.187)",
    style: {
      stroke: "transparent",
      strokeMiterlimit: 10,
      fill: "#e32424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD569\\uCE58\\uAE30 25",
    d: "M0 33.751V21.112L6.083 15.1v17.108l-1.56 1.542zM0 0h6.083v15.1L0 21.112z",
    transform: "translate(52.356 20.187)",
    style: {
      stroke: "transparent",
      strokeMiterlimit: 10,
      fill: "#c41f1f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 38585",
    d: "M174.168 162.3v-1.54l-1.56 1.543z",
    transform: "translate(-115.728 -108.365)",
    style: {
      fill: "#c41f1f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 38586",
    d: "M55.423 98.336s2.591-8.216 9.1-8.216c.9.536 3.8 3.572 2.35 11.432-3.253-1.429-11.449-3.216-11.449-3.216",
    transform: "translate(-37.159 -60.748)",
    style: {
      fill: "#ffd97a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 38587",
    d: "M31.32 98.336s-2.592-8.216-9.1-8.216c-.9.536-3.8 3.572-2.35 11.432 3.254-1.429 11.449-3.216 11.449-3.216",
    transform: "translate(-13.056 -60.748)",
    style: {
      fill: "#ffe39c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 38588",
    d: "M38.359 131.2a1.012 1.012 0 0 0-1.014-1H6.386a1.012 1.012 0 0 0-1.014 1v10.51h32.987z",
    transform: "translate(-3.602 -87.764)",
    style: {
      fill: "#aed45b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 9242",
    transform: "translate(14.511 43.282)",
    style: {
      fill: "#ffe39c"
    },
    d: "M0 0h7.713v10.655H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 9243",
    d: "M3.078 0h30.369a3.079 3.079 0 0 1 3.079 3.079v.973a3.077 3.077 0 0 1-3.077 3.077H3.077A3.077 3.077 0 0 1 0 4.052v-.974A3.078 3.078 0 0 1 3.078 0z",
    transform: "translate(0 36.153)",
    style: {
      fill: "#86b02c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 38589",
    d: "M72.672 110.925H55.423v7.129h17.249a1.012 1.012 0 0 0 1.014-1v-5.123a1.011 1.011 0 0 0-1.014-1",
    transform: "translate(-37.159 -74.772)",
    style: {
      fill: "#698a22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 9244",
    transform: "translate(15.837 36.153)",
    style: {
      fill: "#ffe39c"
    },
    d: "M0 0h5.061v7.129H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 9245",
    transform: "translate(18.367 43.282)",
    style: {
      fill: "#ffd97a"
    },
    d: "M0 0h3.857v10.655H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 9246",
    transform: "translate(18.264 36.153)",
    style: {
      fill: "#ffd97a"
    },
    d: "M0 0h2.634v7.129H0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgGiftbox01);
export default __webpack_public_path__ + "static/media/img_giftbox01.dd7300a8ec4fa3808b1800c92bef1960.svg";
export { ForwardRef as ReactComponent };